import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import {
  withDefaults,
  computed,
  ref,
  reactive,
  onMounted,
  onUnmounted,
} from 'vue';
import Lock from '~/components/Collections/Lock.vue';
import { EState } from '~/types/collections';
import { IOverlayImage } from 'src/types/collections';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImgOverlayCard',
  props: {
    overlayImgs: { default: () => [] },
    showCenterImg: { type: Boolean, default: true },
    showFooter: { type: Boolean, default: false },
    footerTitle: null,
    footerSubtitle: null,
    footerSidenote: null,
    aspectRatio: { default: 13.5 / 8 },
    labelText: null,
    labelDirection: { default: 'right' },
    minHeight: { default: '224px' },
    maxHeight: { default: 'auto' },
    minWidth: { default: 'auto' },
    maxWidth: { default: '675px' }
  },
  emits: ['imgClick', 'footerClick'],
  setup(__props: any, { emit }) {

const props = __props as { overlayImgs: IOverlayImage[], showCenterImg: boolean, showFooter: boolean, footerTitle?: string | number, footerSubtitle?: string | number, footerSidenote?: string | number, aspectRatio: number, labelText?: number | string, labelDirection: 'left' | 'right', minHeight: number | string, maxHeight: number | string, minWidth: number | string, maxWidth: number | string }



const {} = useContext();
const imgAspectRatio = ref<number>(props.aspectRatio);
const isLoading = ref<boolean>(true);
function onImgLoaded($event: Event) {
  isLoading.value = false;
}

const styles = computed(() => {
  const style = {
    '--container-min-height': props.minHeight,
    '--container-max-height': props.maxHeight,
    '--container-min-width': props.minWidth,
    '--container-max-width': props.maxWidth,
  };
  return style;
});

return { __sfc: true,emit, props, imgAspectRatio, isLoading, onImgLoaded, styles, Lock, EState }
}

})